/**
 * DEBUG: product-gallery-dots-debug.js
 * Paste this in browser console on mobile (or with devtools mobile emulation)
 * to see exactly what selectors match and what the DOM looks like.
 */
(() => {
  console.log('=== GALLERY DOTS DEBUG ===');
  console.log('innerWidth:', window.innerWidth);

  // 1. Check top-level anchor
  const mainProduct = document.querySelector('[data-main-product]');
  console.log('[data-main-product]:', mainProduct);

  // 2. Check product photos container
  const productPhotos = document.querySelector('#product-photos');
  console.log('#product-photos:', productPhotos);
  if (productPhotos) {
    console.log('  has [data-gallery-thumbnails]:', productPhotos.hasAttribute('data-gallery-thumbnails'));
    console.log('  has [data-gallery-fullwidth]:', productPhotos.hasAttribute('data-gallery-fullwidth'));
    console.log('  attributes:', [...productPhotos.attributes].map(a => `${a.name}="${a.value}"`).join(', '));
  }

  // 3. Check carousel
  const carousel = document.querySelector('.js-carousel-main');
  console.log('.js-carousel-main:', carousel);
  if (carousel) {
    const slides = carousel.querySelectorAll('.js-slide-item');
    console.log('  total .js-slide-item count:', slides.length);
    slides.forEach((s, i) => {
      console.log(`  slide[${i}] display="${s.style.display}" hidden=${s.hidden} imageId=${s.dataset.imageId}`);
    });

    // Check Flickity
    let flkty = null;
    if (window.Flickity) {
      flkty = window.Flickity.data(carousel);
      console.log('  Flickity.data(carousel):', flkty);
    }
    if (!flkty) {
      flkty = carousel._flickity || carousel.flickity || carousel.__flickity;
      console.log('  carousel._flickity fallback:', flkty);
    }
    if (flkty) {
      console.log('  flkty.selectedIndex:', flkty.selectedIndex);
      console.log('  flkty.selectedElement:', flkty.selectedElement);
      console.log('  flkty.cells.length:', flkty.cells && flkty.cells.length);
    }

    // Check Flickity native dots
    const nativeDots = carousel.querySelector('.flickity-page-dots');
    console.log('  .flickity-page-dots inside carousel:', nativeDots);
  }

  // 4. Check #slider
  const slider = document.querySelector('#slider');
  console.log('#slider:', slider);

  // 5. Check if our dot wrap was injected
  const dotWrap = document.querySelector('.pgd-dot-wrap');
  console.log('.pgd-dot-wrap:', dotWrap);
  if (dotWrap) {
    console.log('  .pgd-dot-wrap parent:', dotWrap.parentElement);
    console.log('  .pgd-dot-wrap innerHTML:', dotWrap.innerHTML);
    console.log('  .pgd-dot-wrap computed display:', getComputedStyle(dotWrap).display);
  }

  // 6. Check if the JS file even ran (look for the flag we set)
  console.log('carousel.__pgdHooked:', carousel && carousel.__pgdHooked);
  console.log('carousel.__pgdDebounce:', carousel && carousel.__pgdDebounce);

  // 7. Show full #product-photos structure
  if (productPhotos) {
    console.log('=== #product-photos children ===');
    [...productPhotos.children].forEach((child, i) => {
      console.log(`  child[${i}]: tag=${child.tagName} id="${child.id}" class="${child.className}"`);
    });
  }

  console.log('=== END DEBUG ===');
})();